import React, { useState } from 'react';
import styles from './LimitsForm.module.css';

import { Input, Table, TextInput } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { notifications } from '@mantine/notifications';

import { useForm } from '@mantine/form';

const PlacesTable = ({ form, loading }) => {
  const { t } = useTranslation();

  const rows = form.getValues().elements.map(({
    limit,
    name,
    consumed,
    type
  }, index) => {

    return (
      <Table.Tr key={type} className={styles.bodyTr}>
        <Table.Td className={styles.nameTh}>{name}</Table.Td>

        <Table.Td className={styles.usedTh}>{consumed}</Table.Td>

        <Table.Td className={styles.statusTh}>
          <TextInput
            className={styles.center}
            placeholder={t('limit.placeholder')}
            key={form.key(`elements.${index}.limit`)}
            type='number'
            disabled={loading}
            {...form.getInputProps(`elements.${index}.limit`)}
          />
        </Table.Td>
      </Table.Tr>
    )
  });

  return (
    <form
      className={styles.wrapper}
    >
      <Table stickyHeader stickyHeaderOffset={0}>
        <Table.Thead className={styles.thead}>
          <Table.Tr className={styles.headTr}>
            <Table.Th className={styles.headThName}>
              <div className={styles.contentName}>
                {t('places.limit.table.header1')}
              </div>
            </Table.Th>

            <Table.Th className={styles.headThName}>
              <div className={styles.content}>
                {t('places.limit.table.header2')}
              </div>
            </Table.Th>

            <Table.Th className={styles.headThStatus}>
              <div className={styles.content}>
                {t('places.limit.table.header3')}
              </div>
            </Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>{rows}</Table.Tbody>
      </Table>
    </form>
  )
}

export default PlacesTable;
